// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"01fd399b","592":"d68fa5b4","856":"fa55a03d","952":"fd974c0e"}[chunkId] + ".chunk.js";
};